__turbopack_context__.v({
  "tooltip": "B-YZvG_tooltip",
  "tooltipContent": "B-YZvG_tooltipContent",
  "tooltipTime": "B-YZvG_tooltipTime",
  "tooltipTitle": "B-YZvG_tooltipTitle",
});
